import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';



function ActionItems({ strengths, weaknesses }) {
  // Utility to split string into sentences and return as list items
  const renderPoints = (items) => {
    return items
      .flatMap(item =>
        item
          .split(',')
          .map(sentence => sentence.trim())
          .filter(Boolean)
      )
      .map((point, i) => <li key={i}>{point}</li>);
  };
  return (
    <div className="w-full">
      <div className="flex flex-col gap-4">
        <div className="flex gap-4">
          <Card className="flex-1 p-4">
            <CardContent className="p-0">
              <Heading level="h3" className="text-lg font-semibold mb-2">Strength :</Heading>
              {strengths.length > 0 ? (
                <ul className="list-disc list-inside space-y-1">{renderPoints(strengths)}</ul>
              ) : (
                <Text>No strengths listed.</Text>
              )}
            </CardContent>
          </Card>
          <Card className="flex-1 p-4">
            <CardContent className="p-0">
              <Heading level="h3" className="text-lg font-semibold mb-2">Weakness:</Heading>
              {weaknesses.length > 0 ? (
                <ul className="list-disc list-inside space-y-1">{renderPoints(weaknesses)}</ul>
              ) : (
                <Text>No weaknesses listed.</Text>
              )}
            </CardContent>
          </Card>
        </div>
        <img 
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/2c96e26d2a7887990babccb81af2c3f3fc766326ed4f4b90ff416752988e5056?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214" 
          alt="" 
          className="w-full max-w-md mx-auto"
        />
      </div>
    </div>
  );
}

export default ActionItems;
